export function isVirtualGoods (goodsName) {
  const physicalKeywords = ['杂志', '玩具'] // 实体商品关键字，包含这些关键字的商品不是虚拟商品
  const virtualKeywords = [
    '代拍', '代付', '代练', '陪玩', '账号出租', '充值', '订阅', '激活码', '到台湾快递', '集運', '國際物流',
    '海快', '海運', '空運', '物流专线', '台湾物流', '小程序', '商務服務'
  ]
  const physical = physicalKeywords.some(keyword => goodsName.includes(keyword))
  const virtual = virtualKeywords.some(keyword => goodsName.includes(keyword))
  if (physical) {
    return false
  }
  return virtual
}

export function isEmbargoGoods (tpCatalog) {
  let embargo = false
  if (tpCatalog) {
    // 海快、空運禁運
    if (String(tpCatalog.catEmbargoSe) === '1' && String(tpCatalog.catEmbargoAir) === '1') {
      embargo = true
    }
    // if (String(tpCatalog.catMold) === '2') {
    //   // 食品
    //   embargo = true
    // }
    const hasCcBan = String(tpCatalog.catCcMaxBox) === '0' || String(tpCatalog.catCcMaxQty) === '0' || String(tpCatalog.catCcMaxWt) === '0'
    // 進口限制
    if (hasCcBan) {
      embargo = true
    }
  }

  return {
    embargo,
    catShptBrief: tpCatalog?.catShptBrief,
  }
}

export function isOptionalSeller (categoryPath, qty) {
  // 不是特定的分类，或者数量小于2，都不可选卖家
  if (!categoryPath || qty < 2) return false
  const firCnames = ['服饰配件/皮带/帽子/围巾', '流行男鞋', '男装', '女士内衣/男士内衣/家居服',
    '女鞋', '女装/女士精品', '箱包皮具/热销女包/男包']
  const name = categoryPath.split('->')[0]
  return firCnames.includes(name)
}
